// Platform-aware display string for the palette shortcut, in the industry
// "modifier+K" format (VS Code, Linear, Notion): ⌘+K on mac, Ctrl+K elsewhere.
export const usePaletteShortcutDisplay = (): string => {
  const isMac =
    typeof navigator !== 'undefined' &&
    navigator.platform.toUpperCase().includes('MAC')
  return isMac ? '⌘ + K' : 'Ctrl + K'
}
